import {
  PAYMENT_ALL,
  PAYMENT_GET,
  PAYMENT_DEL,
  PAYMENT_PUT,
  PAYMENT_POST,
  PAYMENT_LOADING,
  PAYMENT_ERROR,
  PAYMENT_RESET,
} from '../../actions/types';

const initialState = {
  payments: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PAYMENT_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYMENT_GET:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PAYMENT_POST:
      return { ...state, isLoading: false, isCompleted: true };
    case PAYMENT_PUT: {
      const payloadId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && payloadId
          ? state.rows.map((r) =>
              (r._id || r.id) === payloadId ? { ...r, ...action.payload } : r,
            )
          : state.rows,
      };
    }
    case PAYMENT_DEL: {
      const delId = action.payload?._id || action.payload?.id;
      return {
        ...state,
        isLoading: false,
        isCompleted: true,
        rows: state.rows && delId
          ? state.rows.filter((r) => (r._id || r.id) !== delId)
          : state.rows,
        total: state.rows && delId ? Math.max((state.total || 1) - 1, 0) : state.total,
      };
    }
    case PAYMENT_RESET:
      return { PAYMENT: null, isLoading: true, isCompleted: true };
    case PAYMENT_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case PAYMENT_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
